module.exports = __webpack_public_path__ + "img/minebackimg.a3f896b6.png";